import React from 'react';
import { Truck } from 'lucide-react';

const AnnouncementBar = () => {
  const message = (
    <span className="mx-8 inline-flex items-center gap-3 whitespace-nowrap">
      <span className="font-extrabold uppercase tracking-[0.18em]">15% OFF</span>
      <span className="h-1.5 w-1.5 rounded-full bg-white" />
      <span className="inline-flex items-center gap-2 font-semibold">
        <Truck className="h-4 w-4" />
        Free delivery on orders above Rs. 3,000
      </span>
    </span>
  );

  return (
    <div className="overflow-hidden bg-primary text-white">
      <style>{`
        @keyframes announcement-slide {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
      <div className="flex min-h-[42px] items-center">
        <div
          className="flex min-w-max items-center text-sm md:text-base"
          style={{ animation: 'announcement-slide 18s linear infinite' }}
        >
          {message}
          {message}
          {message}
          {message}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
